import { InputData } from "../input/InputData";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { PHPResponse } from "../PHPResponse";
import { CartEntryListResponse } from "./CartEntryListResponse";
import { CartListInput } from "./CartListInput";


export class CartListItemsRequest extends PHPRequest<PHPAdress,CartListInput,CartEntryListResponse>
{
  static readonly adress = PHPAdresses.CART_LIST_ITEMS;

  constructor()
  {
    super( CartListItemsRequest.adress );
  }
}